import { Box, Skeleton, Stack } from '@mui/material';
import Grid from '@mui/material/Grid2';

const responsiveRowSpacing = { xs: 3, md: 5 };
const gridStyle = { xs: 12, md: 6 };

export const BankAccountFormSkeleton = ({
  showBanner = false,
  showSwitch = false,
  fieldCount = 4,
  gridSize = gridStyle,
}) => {
  return (
    <>
      <Box mb={3}>
        <Skeleton variant="text" width={240} height={42} />
        <Skeleton variant="text" width="78%" height={28} />
      </Box>

      {showBanner && (
        <Box mb={showSwitch ? 2 : 3}>
          <Skeleton variant="rounded" width="100%" height={116} />
        </Box>
      )}

      {showSwitch && (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Skeleton
            variant="rounded"
            width={42}
            height={24}
            sx={{ borderRadius: 999 }}
          />
          <Skeleton variant="text" width={160} height={28} sx={{ ml: 1.5 }} />
        </Box>
      )}

      <Grid container rowSpacing={responsiveRowSpacing} columnSpacing={4}>
        {Array.from({ length: fieldCount }).map((_, index) => (
          <Grid key={index} size={gridSize}>
            <Stack spacing={1}>
              <Skeleton variant="text" width={96} height={24} />
              <Skeleton variant="rounded" width="100%" height={47} />
            </Stack>
          </Grid>
        ))}
      </Grid>

      <Stack
        mt={6}
        direction={{ xs: 'column-reverse', md: 'row' }}
        spacing={2}
        justifyContent={{ md: 'space-between' }}
      >
        <Skeleton variant="rounded" width={160} height={42} />
        <Skeleton variant="rounded" width={160} height={42} />
      </Stack>
    </>
  );
};
